import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InputCurrency } from 'components/InputCurrency'
import { Confirm } from 'ui-components/Confirm'

export default function GeneralDiscount(props) {
  const {
    open,
    onSave,
    onCancel,
    saving,
  } = props

  const [percentage, setPercentage] = useState('')

  const handleChange = (evt) => {
    setPercentage(evt.target.value)
  }

  const handleConfirm = () => {
    onSave(percentage)
  }

  return (
    <Confirm
      open={open}
      title="Desconto aplicado a todos os ítens"
      onCancel={onCancel}
      onConfirm={handleConfirm}
      requesting={saving}
    >
      <InputCurrency
        label="Porcentagem"
        name="discount"
        value={percentage}
        onChange={handleChange}
        min={0}
        max={100}
      />
      <p>Este desconto irá remover descontos anteriores</p>
    </Confirm>
  )
}

GeneralDiscount.propTypes = {
  open: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

GeneralDiscount.defaultProps = {
  open: false,
  saving: false,
}
